import styled, { css } from "styled-components"

import { maxWidth, minWidth, when, eq } from "utils"

import { citationStyles } from "./citations/styles"

export const Container = styled.div`
  max-width: 144rem;
  display: flex;
  flex-direction: column;

  ${maxWidth.mobile`
    a:focus,
    button:focus,
    input:focus {
      outline-color: #222;
    }
  `}
`

export const ArticleContainer = styled.article`
  position: relative;
  padding-top: 2.5rem;
  flex-grow: 1;

  ${maxWidth.tablet`
    flex: 0 0 100%;
  `}

  ${minWidth.tablet`
    ${({ isFeatured }) => !isFeatured && "margin-left: 5rem"};
    padding-top: 4rem;
  `}

  ${({ isPremium, isClean }) =>
    (isPremium || isClean) &&
    css`
      margin-left: 0 !important;
      padding-top: 0 !important;
    `}
`

export const MainContent = styled.div`
  display: block;

  ${eq("isPremium", false)`
    display: flex;
    justify-content: space-around;
  `}
`

export const Elements = styled.div`
  width: 100%;
  background-color: ${({ background }) => background};
  ${({ topMargin }) => topMargin && "margin-top: calc(69.4rem - 8rem);"}
  padding-bottom: 3rem;

  ${maxWidth.mobile`
    ${({ topMargin }) => topMargin && "margin-top: calc(50rem + 5rem - 6rem);"}
  `}
`

export const Content = styled.div`
  width: calc(100% - 5.4rem);
  margin: 0 2.7rem;
  padding-bottom: 3rem;
  font-size: 1.8rem;
  line-height: 1.56;
  ${({ fontColor }) => fontColor && `color: ${fontColor};`}

  ${minWidth.tablet`
    max-width: 58rem;
    margin: 0 auto;
    padding-bottom: 4rem;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 72.5rem;
  `}

  p {
    margin: 0;

    &:not(:last-child) {
      ${minWidth.tablet`
        margin-bottom: 2.916rem;
      `}
      margin-bottom: 1.916rem;
    }
  }

  a {
    font-size: 1.8rem;
    word-wrap: break-word;
    font-weight: 400;
    line-height: 1.56;
    text-decoration: underline;
    color: #b5471f;
  }

  img {
    max-width: 100%;
    object-fit: contain;
  }

  ${eq("end", "false")`
    ${minWidth.tablet`
      padding-bottom: 2.916rem;
    `}
    padding-bottom: 1.916rem;
  `}

  ${citationStyles}
`

export const EmptyRailWrapper = styled.div`
  display: flex;
  background-color: ${({ background }) => background};
`

export const LeftRailContent = styled.div`
  width: 100%;
`

export const EmptyRightRail = styled.aside`
  position: relative;
  width: 30rem;
  min-width: 30rem;
  display: none;

  ${minWidth.rightRail`
    display: block;
  `}

  ${when("hasBackground")`
    background-color: #f9f9f9;
  `}
`

export const BottomPlaceholder = styled.div`
  height: 10rem;
  background-color: ${({ background }) => background};
`

export const LeaderboardAdContainer = styled.div`
  position: sticky;
  z-index: 5;
  top: 8rem;
  width: 100%;
  min-height: 12.2rem;
  padding-top: 1rem;
  display: none;
  visibility: hidden;
  background-color: #f9f9f9;

  ${minWidth.mobile`
    display: block;
  `}

  ${eq("isLocked", false)`
    position: relative;
    z-index: 1;
    top: unset;
  `}
`

export const BottomStickyAdContainer = styled.div`
  position: fixed;
  z-index: 10;
  bottom: 0;
  left: 0;
  width: 100%;
  min-height: 9rem;
  display: none;
  visibility: hidden;

  ${minWidth.tablet`
    display: block;
  `};
`

export const MidpointMarker = styled.div`
  position: absolute;
  left: 0;
  width: 100%;
  height: 0.1rem;
  pointer-events: none;
  opacity: 0;
`
export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 10rem;
`

export const BetweenContentAdContainer = styled.div`
  z-index: 5;
  width: 100%;
  background-color: #f9f9f9;
  margin-bottom: 4rem;

  ${minWidth.tablet`
    min-height: 14rem;
  `}
`

export const ObserverContainer = styled.div`
  position: relative;
  height: 0.1rem;
  width: 100%;
`
export const MidPointObserverContainer = styled.div`
  position: absolute;
  height: 0.1rem;
  width: 100%;
  top: 50%;
`

export const ArticleFullContainer = styled.div`
  position: relative;
  margin-bottom: 2rem;
  padding-bottom: 2rem;
  &:last-child {
    border-bottom: none;
    margin-bottom: 0;
  }
`
